import {
  DEFAULT_MUSIC_SETTINGS,
  type MusicSettings,
  normalizeMusicSettings,
} from '../services/MusicEngine';

export const MUSIC_SETTINGS_STORAGE_KEY = 'automation-game-music-settings';

export const applyMusicSettingsDefaults = (
  partial?: Partial<MusicSettings>
): MusicSettings => {
  return normalizeMusicSettings({
    volume: partial?.volume ?? DEFAULT_MUSIC_SETTINGS.volume,
  });
};

export const loadMusicSettings = (): MusicSettings => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return DEFAULT_MUSIC_SETTINGS;
  }

  try {
    const raw = localStorage.getItem(MUSIC_SETTINGS_STORAGE_KEY);
    if (!raw) {
      return DEFAULT_MUSIC_SETTINGS;
    }

    const parsed = JSON.parse(raw) as Partial<MusicSettings>;
    return applyMusicSettingsDefaults(parsed);
  } catch {
    return DEFAULT_MUSIC_SETTINGS;
  }
};

export const saveMusicSettings = (settings: MusicSettings): void => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return;
  }

  try {
    const normalized = applyMusicSettingsDefaults(settings);
    localStorage.setItem(
      MUSIC_SETTINGS_STORAGE_KEY,
      JSON.stringify(normalized)
    );
  } catch {
    // Ignore storage failures
  }
};
